import { render, staticRenderFns } from "./PartnerPrice.vue?vue&type=template&id=67d05417&"
import script from "./PartnerPrice.vue?vue&type=script&lang=js&"
export * from "./PartnerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports